// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__zY0gD","header":"ReportDetails_header__1p51D","title":"ReportDetails_title__bPXzL","left":"ReportDetails_left__2qyyl"};